import request from "@/utils/request.js";
export function fetchList(params) {
    return request({
        url: '/v2/inspect/object/room',
        method: 'GET',
        params
    })
}
export function addOne(data) {
    return request({
        url: '/v2/inspect/object/room',
        method: 'POST',
        data
    })
}

export function fetchOne(id) {
    return request({
        url: `/v2/inspect/object/room/${id}`,
        method: 'get'
    })
}
export function fetchStatus(params) {
    return request({
        url: '/v2/inspect/object/room/status',
        method: 'get',
        params
    })
}